var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid",style:({ gap: _vm.gap, gridTemplateColumns: ("repeat(" + _vm.columns + ", minmax(0px, 1fr))") })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }